// Category color mapping for visual differentiation across the public site
// Colors are HSL values that complement the brand red while maintaining professionalism

export const categoryColors: Record<string, { accent: string; name: string }> = {
  // Inflatables - Warm colors
  'bounce-house': { accent: '0 84% 45%', name: 'Red' },        // Brand Red
  'combo': { accent: '0 84% 45%', name: 'Red' },               // Brand Red
  'toddler': { accent: '280 67% 55%', name: 'Purple' },        // Soft Purple
  
  // Action/Adventure - Cool colors
  'obstacle-course': { accent: '217 91% 50%', name: 'Blue' },  // Vivid Blue
  'interactive': { accent: '25 95% 53%', name: 'Orange' },     // Vibrant Orange
  'inflatable-sports': { accent: '25 95% 53%', name: 'Orange' },
  
  // Water/Slides - Aqua tones
  'slide': { accent: '199 89% 48%', name: 'Cyan' },            // Aqua
  'water-slide': { accent: '199 89% 48%', name: 'Cyan' },
  
  // Games & Extras - Earthy/Neutral
  'game': { accent: '142 71% 40%', name: 'Green' },            // Forest Green
  'party-game': { accent: '142 71% 40%', name: 'Green' },
  'concession': { accent: '45 93% 47%', name: 'Amber' },       // Golden Amber
  'lawn-game': { accent: '142 71% 40%', name: 'Green' },
  
  // Equipment - Professional tones
  'dunk-tank': { accent: '217 91% 50%', name: 'Blue' },
  'table-chair': { accent: '220 14% 46%', name: 'Slate' },
  'lawn-sign': { accent: '45 93% 47%', name: 'Amber' },
  'electronic': { accent: '280 67% 55%', name: 'Purple' },
  
  // Default fallback
  'default': { accent: '0 84% 45%', name: 'Red' },
} as const;

/**
 * Get the HSL accent color for a category
 */
export function getCategoryColor(category: string | undefined): string {
  if (!category) return categoryColors.default.accent;
  
  // Normalize category slug
  const normalized = category.toLowerCase().replace(/_/g, '-');
  
  return categoryColors[normalized]?.accent || categoryColors.default.accent;
}

/**
 * Get the color name for display purposes
 */
export function getCategoryColorName(category: string | undefined): string {
  if (!category) return categoryColors.default.name;
  
  const normalized = category.toLowerCase().replace(/_/g, '-');
  return categoryColors[normalized]?.name || categoryColors.default.name;
}

/**
 * Color indices for components that use numbered color selection (like BentoGrid)
 * These map to the same HSL values for consistency
 */
export const colorPalette = [
  '0 84% 45%',      // 0: Red (Brand)
  '217 91% 50%',    // 1: Blue
  '199 89% 48%',    // 2: Cyan
  '280 67% 55%',    // 3: Purple
  '25 95% 53%',     // 4: Orange
  '142 71% 40%',    // 5: Green
  '45 93% 47%',     // 6: Amber
  '220 14% 46%',    // 7: Slate
] as const;

export function getColorByIndex(index: number): string {
  return colorPalette[index % colorPalette.length];
}
